import React, {useState} from 'react'
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import { Fragment } from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { setcurrentPair } from '../Trader/tradingSlice';
import { useNavigate } from 'react-router-dom';
import BalanceCard from '../Cards/BalanceCard';
import AssetButtons from './AssetsButtons';
import Transactions from '../Transactions/Transactions';
const Assets = () => {

    const formatPrice = (amount)=> new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', currencySign: 'standard' }).format(amount);
    const coins = useSelector((state) => state.coins.coins);
    const coinRates = useSelector((state) => state.coins.coinRates);

    const [coinSymbol, setCoinSymbol] = useState('BINANCE:BTCUSDT');
    const availableCoins = ['XMR', 'USDT', 'USDTERC20', 'XLM', 'ETH', 'TRX', 'XRP', 'BTC', 'LTC', 'BCH', 'DOGE', 'DASH', 'BNB'];
    const fundings = useSelector((state) => state.wallet.fundings);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const tradings = useSelector((state) => state.history.tradings);
    const investments = useSelector((state) => state.history.investments);
    const withdrawals = useSelector((state) => state.history.withdrawals);

    const calculate24hrChange = (coin) => {
      let rate = 0;
      coinRates.forEach(coinRater => {
        if (coinRater.symbol === coin) {
          rate = parseFloat(coinRater.changePercent24Hr);
        }
      });

      return rate;
    }

    const calculateBalance = (coin) => {
      let amount = 0;

      fundings.forEach(fund => {
        if (fund.gateway === coin) {
          amount += parseFloat(fund.amount);
        }
        });

        tradings.forEach(trade => {
          if (trade.pair === coin) {
            amount += parseFloat(trade.profit);
          }
          });

          investments.forEach(investment => {
            if (investment.payment_source === coin && investment.status != 'declined') {
              amount -= parseFloat(investment.amount_invested);
            }
            });

            withdrawals.forEach(withdrawal => {
              
              if (withdrawal.source === coin && withdrawal.status != 'declined') {
                amount -= parseFloat(withdrawal.amount);
              }
              });
      
        return amount;
    }
    
  return (
    <div style={{marginTop: '75px'}}>

      <BalanceCard/>
      <AssetButtons/>
      <Transactions/>
        
    </div>
  )
}

export default Assets
